// tslint:disable:max-line-length

import React from 'react';

export const ArrowCaretRightSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M9.75193 8.83205C10.3457 8.43623 10.3457 7.56377 9.75192 7.16795L6.5547 5.03647C5.89014 4.59343 5 5.06982 5 5.86852V10.1315C5 10.9302 5.89015 11.4066 6.5547 10.9635L9.75193 8.83205Z" />
    </svg>
  );
};
